import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Box,
  Typography,
  LinearProgress,
  Alert,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

type DialogProps = {
  confirm: () => void
  isSubmitting: boolean
  hasFailed: boolean
}

export const PaymentDialog = ({ confirm, isSubmitting, hasFailed }: DialogProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Dialog fullWidth open onClose={() => navigate(-1)} maxWidth="xs">
      <DialogTitle>{t('payment_otc_confirm_title')}</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>{t('payment_otc_confirm_text')}</Typography>
        <Typography gutterBottom>{t('payment_otc_second_confirm_text')}</Typography>
        {isSubmitting && (
          <LinearProgress
            sx={{
              position: 'relative',
              width: '100%',
            }}
          />
        )}
        {hasFailed && (
          <Alert severity="error" sx={{ marginTop: (theme) => theme.spacing(2) }}>
            <strong>{t(`shipment_error_submit_failed_title`)}</strong>
            <br />
            {t(`shipment_error_submit_failed_reason`)}
          </Alert>
        )}
      </DialogContent>

      <DialogActions>
        <Box ml={2}>
          <Button onClick={() => navigate(-1)} color="primary">
            {t('payment_otc_btn_cancel')}
          </Button>
        </Box>
        <Button onClick={() => confirm()} id="payment-btn-confirm" disabled={isSubmitting}>
          {t('payment_otc_btn_confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
